/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück zur Liste`
};

const en_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Back to list`
};

const es_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Volver a la lista`
};

const fr_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Retour à la liste`
};

const it_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Torna alla lista`
};

const nl_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Terug naar de lijst`
};

const pt_poi_datasheet__back_to_list = /** @type {(inputs: {}) => string} */ () => {
	return `Voltar à lista`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__back_to_list = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__back_to_list(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__back_to_list", locale)
	if (locale === "de") return de_poi_datasheet__back_to_list(inputs)
	if (locale === "en") return en_poi_datasheet__back_to_list(inputs)
	if (locale === "es") return es_poi_datasheet__back_to_list(inputs)
	if (locale === "fr") return fr_poi_datasheet__back_to_list(inputs)
	if (locale === "it") return it_poi_datasheet__back_to_list(inputs)
	if (locale === "nl") return nl_poi_datasheet__back_to_list(inputs)
	return pt_poi_datasheet__back_to_list(inputs)
};